/**
 * The sidebar footer's build label (polish 4): the running bundle, so a check on a tablet can
 * confirm which build it has without DevTools. The main bundle's name is read at runtime from
 * the page's own script tag (CRA's production build writes /static/js/main.<hash>.js into
 * index.html): "Build main.4ff45aea", the full file name as the tooltip. The deploy's smoke
 * stamps the same file name, so the two can be compared by eye.
 *
 * No build SHA: none reaches the bundle (the image's GIT_SHA is a label on the nginx stage, not
 * a REACT_APP_* variable), and adding one is out of scope here.
 */
import { useMemo } from 'react';

const MAIN_BUNDLE = /(?:^|\/)(main\.([0-9a-f]{6,}))\.js(?:[?#]|$)/;

/** { label, title } from the page's script tags. */
export function readBuildLabel(doc = typeof document !== 'undefined' ? document : null) {
  const srcs = doc ? Array.from(doc.querySelectorAll('script[src]')).map((s) => s.getAttribute('src') || '') : [];
  for (const src of srcs) {
    const m = src.match(MAIN_BUNDLE);
    if (m) return { label: `Build ${m[1]}`, title: `${m[1]}.js` };
  }
  // The dev server (bundle.js) or a test: no hash to show, and none is made up.
  const files = srcs.map((s) => s.split(/[?#]/)[0].split('/').pop()).filter(Boolean);
  return { label: 'Build: development', title: files.length ? `No main.<hash>.js on this page (${files.join(', ')})` : 'No main.<hash>.js on this page' };
}

export default function BuildLabel() {
  const { label, title } = useMemo(() => readBuildLabel(), []);
  return (
    <div data-testid="sidebar-build" title={title} style={{ marginTop: '2px' }}>
      {label}
    </div>
  );
}
